__turbopack_context__.v({
  "container": "CloudinaryVideo-module__ZQ-0XG__container",
  "desktop": "CloudinaryVideo-module__ZQ-0XG__desktop",
  "fadeInItems": "CloudinaryVideo-module__ZQ-0XG__fadeInItems",
  "loaded": "CloudinaryVideo-module__ZQ-0XG__loaded",
  "mobile": "CloudinaryVideo-module__ZQ-0XG__mobile",
  "spacing--lg": "CloudinaryVideo-module__ZQ-0XG__spacing--lg",
  "spacing--md": "CloudinaryVideo-module__ZQ-0XG__spacing--md",
  "spacing--sm": "CloudinaryVideo-module__ZQ-0XG__spacing--sm",
  "spacing--xl": "CloudinaryVideo-module__ZQ-0XG__spacing--xl",
  "spacing--xs": "CloudinaryVideo-module__ZQ-0XG__spacing--xs",
  "spacing--xxl": "CloudinaryVideo-module__ZQ-0XG__spacing--xxl",
  "spacing--xxs": "CloudinaryVideo-module__ZQ-0XG__spacing--xxs",
  "spacing--xxxl": "CloudinaryVideo-module__ZQ-0XG__spacing--xxxl",
  "spacing--xxxs": "CloudinaryVideo-module__ZQ-0XG__spacing--xxxs",
});
